import React, { useEffect, useRef, useState } from "react";
import { FieldArray, FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as jnb from "react-bootstrap";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import AdmissionResultAnalysisReport from "./AdmissionResultAnalysisReport";
import { FaTrash } from "react-icons/fa";
import { use } from "react";
// import FinancialResources from "./FinalcialResources";
const NewConversionProgramForDg = ({ typee }) => {
  const [mergeStatus, setMergeStatus] = useState(false);
  const [showEditTable, setShowEditTable] = useState(false);
  const [enhanceStatus, setEnhanceStatus] = useState(false);
  const [CourseCategory, setCourseCategory] = useState([]);
  const [course, setCourse] = useState([]);
  const [program, setProgram] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [isPaymentDone, setIsPaymentDone] = useState(false);
  const [medium, setMedium] = useState([]);
  const college = sessionStorage.getItem("user_id")
  console.log("college", college)
  const initialValues = {
    selectedCourses: [],
    intakeDetails: [],
    raisedIntake: "",
    courseConversionDetails: [
      {
        existing_course: "",
        existing_intake: "",
        proposed_change_name: "",
        revised_intake: "",
        nature: "",
        course_cat_id: "",
        amount: "",
        section_no: "",
        proposed_stream: "",
        proposed_single_major: "",
        proposed_course_id: "",
        proposed_course: "",
        mediumCode: "",
        regSelf: "",
      },
    ],
    justification: "",
  };

  const validationSchema = Yup.object().shape({
    // raisedIntake: Yup.string().required(ERROR_MSG),
    courseConversionDetails: Yup.array().of(
      Yup.object().shape({
        existing_course: Yup.string().required(ERROR_MSG),
        existing_intake: Yup.string().required(ERROR_MSG),
        proposed_single_major: Yup.string().required(ERROR_MSG),
        proposed_change_name: Yup.string().required(ERROR_MSG),
        mediumCode: Yup.string().required(ERROR_MSG),
        //   revised_intake: Yup.string()
        //     .required("Proposed intake is required")
        //     .test("is-number", "Proposed intake must be a number", (value) => {
        //       return !isNaN(Number(value));
        //     })
        //     .test("intake-validation", "Invalid intake value", function (value) {
        //       const numValue = Number(value);
        //       if (!value || value === "") return true;
        //       const raisedIntakeValue = this.options.context?.raisedIntake; //NOSONAR
        //       if (!raisedIntakeValue) {
        //         return this.createError({//NOSONAR
        //           message: "Please select GO No. 33 eligibility first"
        //         });
        //       }
        //       if (raisedIntakeValue === "Yes") {
        //         if (numValue < 20) {
        //           return this.createError({//NOSONAR
        //             message: "For G.O. Ms.no.33, proposed intake cannot be less than 20"
        //           });
        //         }
        //         if (numValue > 100) {
        //           return this.createError({//NOSONAR
        //             message: "For G.O. Ms.no.33, proposed intake cannot exceed 100"
        //           });
        //         }
        //       }
        //       if (raisedIntakeValue === "No") {
        //         const existingIntakeNum = Number(this.parent.existing_intake);//NOSONAR
        //         if (numValue < 20) {
        //           return this.createError({//NOSONAR
        //             message: "Proposed intake cannot be less than 20"
        //           });
        //         }
        //         if (numValue > existingIntakeNum) {
        //           return this.createError({//NOSONAR
        //             message: `Proposed intake cannot exceed existing intake (${existingIntakeNum})`
        //           });
        //         }
        //       }

        //       return true;
        //     }),
      }),
    ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to save the details?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            intakeType: "NameChange",
            raisedIntake: values.raisedIntake,
            changecloselist: values.courseConversionDetails.map((item) => ({
              courseId: parseInt(item.existing_course),
              courseGrcode: item.course_group_code,
              courseType: item.course_cat_id,
              existingIntake: parseInt(item.existing_intake) || 0,
              proposedName: item.proposed_change_name,
              revisedIntake: parseInt(item.revised_intake) || 0,
              regSelf: item.regSelf,
              nature: "NameChange",
              category: item.mediumCode || "",
            })),
          };
          const url = `${config.url.FAC_URL}saveIntakeChanges`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc,
                  icon: "success",
                  backdrop: false,
                  confirmButtonText: "OK",
                }).then((result) => {
                  if (result.isConfirmed) {
                    GetIntakeDetails();


                  }
                });
              } else {
                Swal.fire({
                  text: res.data?.sdesc,
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error("Submission Error:", err);
              Swal.fire({
                text: "An error occurred during submission.",
                icon: "error",
              });
            });
        }
      });
    },
  });
  useEffect(() => {
    raisedIntake();
    GetMediumList();
  }, [])
  function GetMediumList() {
    CommonAxiosGet(`${config.url.FAC_URL}getMediumList`).then((res) => {
      setMedium(res?.data?.scode === "01" ? res.data.getMediumList || [] : []);
    });
  }
  function raisedIntake() {
    const url = `${config.url.FAC_URL}getAdmissionDtls`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          const areaData = res.data.areaType[0];
          if (
            res.data.areaType_status &&
            Array.isArray(res.data.areaType) &&
            res.data.areaType.length > 0
          ) {
            formik.setFieldValue(
              "raisedIntake",
              res.data.areaType[0].raised_intake || ""
            );
          }
        }
      })
      .catch((err) => console.error("Error fetching saved admission data:", err));
  };
  const handleSelectAll = (e) => {
    if (isPaymentDone) {
      Swal.fire({ icon: "warning", text: "Already Edited" });
      return;
    } else {
      if (e.target.checked) {
        const allIds = courseData
          .filter(c => !isCourseAlreadyAdded(c.course_id))
          .map((c) => c.sno);
        setFieldValue("selectedCourses", allIds);
      } else {
        setFieldValue("selectedCourses", []);
      }
    }
  };
  /* ROW SELECT */
  const handleRowSelect = (sno, checked) => {
    if (enhanceStatus) {
      Swal.fire({ icon: "warning", text: "Already Edited" });
      return;
    }
    if (checked) {
      if (values.selectedCourses.length >= 3) {
        Swal.fire({
          icon: "warning",
          text: "You can select only 3 courses maximum",
        });
        return;
      }

      setFieldValue("selectedCourses", [
        ...values.selectedCourses,
        sno,
      ]);
    }
    // if (checked) {
    //   setFieldValue("selectedCourses", [
    //     ...values.selectedCourses,
    //     sno,
    //   ]);
    // } 
    else {
      const updatedSelectedCourses = values.selectedCourses.filter(
        (id) => id !== sno
      );
      setFieldValue("selectedCourses", updatedSelectedCourses);
      const uncheckedCourse = courseData.find(
        (c) => c.sno === sno
      );
      if (uncheckedCourse) {
        const updatedConversionDetails =
          values.courseConversionDetails.filter(
            (row) =>
              String(row.existing_course) !==
              String(uncheckedCourse.course_id)
          );
        setFieldValue(
          "courseConversionDetails",
          updatedConversionDetails
        );
        const updatedIntakeDetails =
          values.intakeDetails.filter(
            (row) =>
              String(row.course_id) !==
              String(uncheckedCourse.course_id)
          );

        setFieldValue(
          "intakeDetails",
          updatedIntakeDetails
        );
        if (updatedConversionDetails.length === 0) {
          setShowEditTable(false);
        }
      }
    }
  };
  /* EDIT */
  const handleEdit = () => {
    const selectedRows = courseData.filter((course) =>
      values.selectedCourses.includes(course.sno)
    );
    const hasExistingData = values.courseConversionDetails.length > 0 &&
      values.courseConversionDetails.some(detail => detail.existing_course);
    if (hasExistingData) {
      const existingIds = values.courseConversionDetails.map(detail =>
        String(detail.existing_course)
      );
      const newSelectedRows = selectedRows.filter(row =>
        !existingIds.includes(String(row.course_id))
      );
      const currentCount = values.courseConversionDetails.length;
      const newCount = newSelectedRows.length;
      const totalAfterAdd = currentCount + newCount;
      if (totalAfterAdd > 3) {
        Swal.fire({
          icon: "warning",
          title: "Maximum 3 conversions allowed",
          html: `You already have <strong>${currentCount}</strong> conversion(s).<br/>
                 Trying to add <strong>${newCount}</strong> more would exceed the limit of <strong>3</strong>.<br/>
                 Please delete some existing rows or select fewer courses.`,
          confirmButtonText: "OK",
        });
        return;
      }
      if (newSelectedRows.length === 0) {
        Swal.fire({
          icon: "warning",
          text: "These courses are already in the below table",
        });
        return;
      }
      const newIntakeData = newSelectedRows.map((c) => ({
        sno: c.sno,
        course_id: c.course_id,
        course_name: c.course_name,
        intake: c.intake,
        course_cat_id: c.course_cat_id,
        course_cat_name: c.course_cat_name,
        course_group_code: c.course_group_code,
        course_group_desc: c.course_group_desc,
        change_value: "",
        effective: "",
        aicte_ref: "",
        section_no: c.section_no ?? "",
        existing_stream_desc: c.course_group_desc,
        existing_single_major_name: c.course_cat_name,
        existing_branch_name: c.course_name,
        regSelf: c.reg_self,

      }));
      const newChangeData = newSelectedRows.map((c) => ({
        existing_course: String(c.course_id),
        existing_intake: String(c.intake),
        proposed_change_name: "",
        revised_intake: "",
        nature: "",
        course_group_code: c.course_group_code,
        course_type: c.course_noc_type,
        section_no: c.section_no ?? "",
        proposed_stream: String(c.course_group_code),
        proposed_single_major: "",
        proposed_course: "",
        amount: "10000",
        existing_stream_desc: c.course_group_desc,
        existing_single_major_name: c.course_cat_name,
        existing_branch_name: c.course_name,
        regSelf: c.reg_self,
      }));
      setFieldValue("intakeDetails", [...values.intakeDetails, ...newIntakeData]);
      setFieldValue("courseConversionDetails", [...values.courseConversionDetails, ...newChangeData]);
    } else {
      const data = selectedRows.map((c) => ({
        sno: c.sno,
        course_id: c.course_id,
        course_name: c.course_name,
        intake: c.intake,
        course_cat_id: c.course_cat_id,
        course_cat_name: c.course_cat_name,
        course_group_code: c.course_group_code,
        course_group_desc: c.course_group_desc,
        change_value: "",
        effective: "",
        aicte_ref: "",
        section_no: c.section_no ?? "",
        existing_stream_desc: c.course_group_desc,
        existing_single_major_name: c.course_cat_name,
        existing_branch_name: c.course_name,
      }));
      setFieldValue("intakeDetails", data);
      const changeData = selectedRows.map((c) => ({
        existing_course: String(c.course_id),
        existing_intake: String(c.intake),
        proposed_change_name: "",
        revised_intake: "",
        nature: "",
        course_group_code: c.course_group_code,
        course_type: c.course_noc_type,
        section_no: c.section_no ?? "",
        proposed_stream: String(c.course_group_code),
        proposed_single_major: "",
        proposed_course: "",
        amount: "10000",
        existing_stream_desc: c.course_group_desc,
        existing_single_major_name: c.course_cat_name,
        existing_branch_name: c.course_name,
        regSelf: c.reg_self,

      }));
      setFieldValue("courseConversionDetails", changeData);
      setTimeout(() => {
        changeData.forEach((row, idx) => {
          if (row.proposed_stream) {
            GetCourseCategory(row.proposed_stream, idx);
          }
        });
      }, 100);
    }
    setShowEditTable(true);
    const el = document.getElementById("editTable");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
  }, [CourseCategory]);
  //  ********** field array get api************
  const GetIntakeDetails = () => {
    const url = `${config.url.FAC_URL}getInputDetails/${"NameChange"}/${college}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.namechange_status && Array.isArray(res.data.namechange) && res.data.namechange.length > 0) {
          setMergeStatus(res.data.namechange_status);
          const mappedData = res.data.namechange.map((item) => {
            const originalCourse = courseData.find(
              (c) => Number(c.course_id) === Number(item.course_id_old)
            );
            return {
              existing_course: String(item.course_id_old ?? ""),
              existing_intake: String(item.existing_intake ?? ""),
              proposed_stream: String(item.course_group_code ?? ""),
              proposed_single_major: String(item.course_cat_id ?? ""),
              proposed_change_name: String(item.course_id ?? ""),
              proposed_course: String(item.course_id ?? ""),
              revised_intake: String(item.revised_intake ?? ""),
              section_no: String(
                item.section_no ?? originalCourse?.section_no ?? ""
              ),
              nature: item.nature ?? "",
              amount: "10000",
              existing_stream_desc:
                originalCourse?.course_group_desc || item.course_group_desc || "",
              existing_single_major_name:
                originalCourse?.course_cat_name || item.course_cat_name_old || "",
              existing_branch_name:
                originalCourse?.course_name || item.course_name_old || "",
              mediumCode: item.medium_code ?? "",
              regSelf: item.reg_self
            };
          });
          formik.setFieldValue("courseConversionDetails", mappedData);
          mappedData.forEach((row, index) => {
            if (row.proposed_stream) {
              GetCourseCategory(row.proposed_stream, index);
            }
            if (row.proposed_single_major) {
              GetCourses(row.proposed_single_major, index);
            }
            setShowEditTable(true);
          });
          const intakeDetails = res.data.namechange
            .map((item) => {
              const course = courseData.find((c) => c.course_id === item.course_id);
              return {
                sno: course?.sno || null,
                course_id: item.course_id,
                course_name: course?.course_name || "",
                intake: item.existing_intake,
                course_cat_id: course?.course_cat_id,
                course_cat_name: course?.course_cat_name,
                course_group_code: course?.course_group_code,
                course_group_desc: course?.course_group_desc,
                course_type: course?.course_noc_type,
                change_value: item.proposed_name,
                effective: item.revised_intake,
                aicte_ref: item.nature,
              };
            })
            .filter((row) => row.sno);
          formik.setFieldValue("intakeDetails", intakeDetails);
          setShowEditTable(true); // ← SHOW THE TABLE
        } else {
          setMergeStatus(false);
          setEnhanceStatus(false);
          formik.setFieldValue("courseConversionDetails", [
            {
              existing_course: "",
              existing_intake: "",
              proposed_change_name: "",
              revised_intake: "",
              nature: "",
              mediumCode: "",
              reg_self: "",
            },
          ]);
          formik.setFieldValue("intakeDetails", []);
          formik.setFieldValue("justification", "");
          setShowEditTable(false);
        }
      })
      .catch((err) => {
        console.error("Error fetching intake details:", err);
      });
  };

  useEffect(() => {
    if (courseData && courseData.length > 0) {
      GetIntakeDetails();
    }
  }, [courseData]);
  const formikRef = useRef();
  const { values, setFieldValue } = formik;
  function GetCoursesByProgramType(course_group_code, index) {
    if (!course_group_code) return;

    let url = `${config.url.FAC_URL}getSpecilization/${course_group_code}`;

    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setCourse((prev) => ({
          ...prev,
          [index]: res.data.Specilization || [],
        }));
      } else {
        setCourse((prev) => ({
          ...prev,
          [index]: [],
        }));
      }
    });
  }
  useEffect(() => {
    GetProgram();
  }, [])
  function GetProgram() {
    let url = config.url.FAC_URL + `getCourseGroupList`; //degree
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setProgram(res?.data?.getCourseGroupList);
      } else {
        setProgram([]);
      }
    });
  }
  function GetCourses(CourseCategory, index) {
    if (!CourseCategory) return;
    let url = `${config.url.FAC_URL}getSpecilization/${CourseCategory}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.scode === "01") {
          setCourse((prevState) => ({
            ...prevState,
            [index]: res?.data?.Specilization || [],
          }));
        } else {
          setCourse((prevState) => ({
            ...prevState,
            [index]: [],
          }));
        }
      })
      .catch((err) => {
        console.error(err);
        setCourse((prevState) => ({
          ...prevState,
          [index]: [],
        }));
      });
  }
  useEffect(() => {
    if (values.courseConversionDetails.length > 0) {
      values.courseConversionDetails.forEach((row, idx) => {
        if (row.proposed_stream) {
          GetCourseCategory(row.proposed_stream, idx);
        }
      });
    }
  }, [values.courseConversionDetails]);
  // function GetCourseCategory(program, index) {
  //   if (!program) return;
  //   // let url = `${config.url.FAC_URL}getCourseCategoryList/${program}`;
  //   let url = `${config.url.FAC_URL}courseCategoryForProgramintake/${program || 118}`;
  //   CommonAxiosGet(url).then((res) => {
  //     if (res?.data?.scode === "01") {
  //       let options = res?.data?.getCourseCategoryList
  //         ?.filter((ds) =>
  //           ds.course_cat_name?.toLowerCase().includes("honours")
  //         )
  //         ?.map((ds, i) => (
  //           <option key={i} value={ds.course_cat_id}>
  //             {ds.course_cat_name}
  //           </option>
  //         ));
  //       setCourseCategory((prev) => ({ ...prev, [index]: options }));
  //     } else {
  //       setCourseCategory((prev) => ({ ...prev, [index]: [] }));
  //     }
  //   });
  // }


  function GetCourseCategory(program, index) {
  if (!program) return;
  const currentRow = values.courseConversionDetails[index];
  let url = `${config.url.FAC_URL}courseCategoryForProgramintake/${program || 118}`;

  CommonAxiosGet(url).then((res) => {
    if (res?.data?.scode === "01") {
      let list = res?.data?.getCourseCategoryList || [];

      // Keep only true major-level "Honours" entries — drop anything that
      // is actually a branch/specialization name (e.g. "History").
      let filtered = list.filter((ds) => {
        const name = ds.course_cat_name?.toLowerCase() || "";
        if (!name.includes("honours")) return false;
        const isBranchName = courseData.some(
          (c) => c.course_name?.toLowerCase() === name
        );
        return !isBranchName;
      });

      // Ensure the row's own existing major (e.g. "B A Honours") is present,
      // even if the API happened to leave it out for this group.
      const existingCourse = courseData.find(
        (c) => String(c.course_id) === String(currentRow?.existing_course)
      );
      if (
        existingCourse &&
        !filtered.some(
          (ds) => String(ds.course_cat_id) === String(existingCourse.course_cat_id)
        )
      ) {
        filtered = [
          { course_cat_id: existingCourse.course_cat_id, course_cat_name: existingCourse.course_cat_name },
          ...filtered,
        ];
      }

      const options = filtered.map((ds, i) => (
        <option key={i} value={ds.course_cat_id}>{ds.course_cat_name}</option>
      ));
      setCourseCategory((prev) => ({ ...prev, [index]: options }));
    } else {
      setCourseCategory((prev) => ({ ...prev, [index]: [] }));
    }
  });
}
  useEffect(() => {
    GetCourseDetails();
  }, [])
  function GetCourseDetails() {
    const url = `${config.url.FAC_URL}getCourseIntakeList`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true && res?.data?.list?.length > 0) {

          const filteredCourses = res?.data?.list?.filter(
            (item) => item.course_group_desc !== "PG ACADEMIC"
          );

          setCourseData(filteredCourses);

          // setCourseData(res?.data?.list);


        } else {
          setCourseData([]);
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }
  const isCourseAlreadyAdded = (courseId) => {
    return values.courseConversionDetails.some(
      (detail) => String(detail.existing_course) === String(courseId)
    );
  };
  console.log("formik.erros", formik.errors)
  return (
    <>
      <AdmissionResultAnalysisReport />
      <h5 className="mb-3 innerheader-new">
        <span>Details of Existing UG programmes</span>      </h5>
      <div className="table-responsive">
        {/* Note 1 */}
        <div className="note-box">
          <span className="note-title">📢 Note:</span>
          <span>
            <strong>Colleges must select only the programme(s) offered by their respective affiliating University.</strong>
          </span>
        </div>

        {/* Note 2 */}
        <div className="note-box">
          <span className="note-title" >
            ⚠️ Important:
          </span>
          <span>
            <strong>BBA</strong> and <strong>BCA</strong> programmes are{" "}
            <strong>not eligible for conversion</strong>. Please do not select these
            programmes for conversion.
          </span>
        </div>


        <table className="table table-bordered table-striped">
          <thead className="table-primary">
            <tr>
              <th>
                {!isPaymentDone ? (
                  <>
                    <input
                      type="checkbox"
                      checked={
                        courseData.filter(c => !isCourseAlreadyAdded(c.course_id)).length > 0 &&
                        values.selectedCourses.length === courseData.filter(c => !isCourseAlreadyAdded(c.course_id)).length
                      }
                      onChange={handleSelectAll}
                    />
                    {/* <input type="checkbox" checked={courseData.length > 0 && values.selectedCourses.length === courseData.length} onChange={handleSelectAll} /> SL.No */}
                  </>
                ) : (
                  "SL.No"
                )}
              </th>

              <th>Academic Program Type</th>
              <th>Course / Program</th>
              <th>Branch/Specialization</th>
              <th>Medium</th>
              <th>Regular/Self Financed</th>
              <th>Permanent/Temporary</th>
              <th>Section</th>
              <th>Intake</th>
              {/* <th>Total</th> */}
            </tr>
          </thead>
          <tbody>
            {courseData.length > 0 ? (
              courseData.map((course, index) => (
                <tr key={course.sno}>
                  <td>
                    {!isPaymentDone ? (
                      [86, 87, 89].includes(course.course_cat_id) ? (
                        <span>{index + 1}</span>
                      ) : (
                        <>
                          <input
                            type="checkbox"
                            checked={
                              isCourseAlreadyAdded(course.course_id)
                                ? true
                                : values.selectedCourses.includes(course.sno)
                            }
                            onChange={(e) => handleRowSelect(course.sno, e.target.checked)}
                            disabled={isCourseAlreadyAdded(course.course_id)}
                            title={isCourseAlreadyAdded(course.course_id) ? "This course is already added in the conversion table" : ""}
                          />
                          {index + 1}
                        </>
                      )
                    ) : (
                      index + 1
                    )}
                  </td>
                  <td>{course.course_group_desc}</td>
                  <td>{course.course_cat_name}</td>
                  <td>{course.course_name}</td>
                  <td>{course.medium_name || "-"}</td>
                  <td>{course.reg_self === "S" ? "Self Finance" : course.reg_self === "R" ? "Regular" : ""}</td>
                  <td>{course.course_noc_type}</td>
                  <td>{course.section_no}</td>
                  <td>{course.intake}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center text-danger fw-bold">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
          <tfoot className="table-secondary">
            <tr>
              <td colSpan="8" className="text-end fw-bold">Total Intake:</td>
              <td className="fw-bold text-center">
                {courseData.reduce((sum, course) => sum + (Number(course.intake) || 0), 0)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {!enhanceStatus && (
        <div className="d-flex justify-content-end mt-4">
          <button type="button" className="btn btn-primary" onClick={handleEdit} disabled={!values.selectedCourses.length}>
            Convert
          </button>
        </div>
      )}
      {/* SECOND TABLE */}
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          {showEditTable && (
            <>
              <h5 className="mb-3 mt-3 innerheader-new">
                <span>Details of proposed conversion(s) of UG programmes</span>
                {typee === "close" && (
                  <>
                    <h6 className="text-danger mt-2">These courses will be permanently closed and will not be available for future intake.</h6>
                  </>
                )}
              </h5>
              {/* <div className="mb-3">
                <label className="fw-bold me-3">
                  Is your College eligible for raise in Intake as per G.O. Ms.no.33, of Higher Education (C.E) Department, dt.08.06.2026 :
                </label>
                <div className="d-inline-block">
                  <label className="me-3">
                    <Field
                      type="radio"
                      name="raisedIntake"
                      value="Yes"
                      onChange={(e) => {
                        const value = e.target.value;
                        formik.setFieldValue("raisedIntake", value);
                        const conversionDetails = formik.values.courseConversionDetails;
                        const clearedDetails = conversionDetails.map((detail) => ({
                          ...detail,
                          revised_intake: ""
                        }));
                        formik.setFieldValue("courseConversionDetails", clearedDetails);
                      }}
                    />
                    {" "}Yes
                  </label>

                  <label>
                    <Field
                      type="radio"
                      name="raisedIntake"
                      value="No"
                      onChange={(e) => {
                        const value = e.target.value;
                        formik.setFieldValue("raisedIntake", value);
                        const conversionDetails = formik.values.courseConversionDetails;
                        const clearedDetails = conversionDetails.map((detail) => ({
                          ...detail,
                          revised_intake: ""
                        }));
                        formik.setFieldValue("courseConversionDetails", clearedDetails);
                      }}
                    />
                    {" "}No
                  </label>
                </div>
                <ErrorMessage name="raisedIntake" component="div" className="text-danger small mt-1" />
              </div> */}
              <FieldArray name="courseConversionDetails">
                {({ remove }) => (
                  <div id="editTable" className="table-responsive">
                    <table className="table table-hover align-middle mt-4">
                      <thead className="table-primary">
                        <tr className="text-center small">
                          <th>Sl No.</th>
                          <th>Name of Existing Single Major</th>
                          <th>Branch/Specialization</th>
                          <th>No. of Sections Sanctioned</th>
                          <th>Sanctioned Intake</th>
                          <th>Name of the Proposed Single Major</th>
                          <th>Proposed Branch/Specialization</th>
                          <th>Medium</th>
                          <th>Regular  /Self-Financed</th>
                          <th>Proposed Intake</th>
                          {/* <th>Type</th> */}
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {values.courseConversionDetails.map((row, index) => (
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            {/* <td>{row.course_group_desc}</td> */}
                            {/* <td>{courseData.find((c) => c.course_id == row.existing_course)?.course_group_desc || row.existing_stream_desc || "-"}</td> */}
                            <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_cat_name || row.existing_single_major_name || "-"}</td>
                            <td>{courseData.find((c) => c.course_id === row.existing_course)?.course_name || row.existing_branch_name || "-"}</td>
                            <td>
                              <input value={row.section_no} className="form-control form-control-sm" disabled />
                            </td>
                            <td>
                              <input value={row.existing_intake} className="form-control form-control-sm" disabled />
                            </td>
                            {typee !== "close" && (
                              <>
                                <td>
                                  <Field
                                    as="select"
                                    className="form-control"
                                    name={`courseConversionDetails[${index}].proposed_single_major`}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      formik.setFieldValue(`courseConversionDetails[${index}].proposed_single_major`, value);
                                      formik.setFieldValue(`courseConversionDetails[${index}].proposed_course`, "");
                                      GetCourses(value, index);
                                    }}
                                  >
                                    <option value="">--Select--</option>
                                    {CourseCategory[index] || []}
                                  </Field>
                                  <ErrorMessage name={`courseConversionDetails[${index}].proposed_single_major`} component="div" className="text-danger small" />
                                </td>
                                <td>
                                  <Field
                                    as="select"
                                    className="form-control"
                                    name={`courseConversionDetails[${index}].proposed_change_name`}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      formik.setFieldValue(`courseConversionDetails[${index}].proposed_change_name`, value);
                                      const currentRow = formik.values.courseConversionDetails[index];
                                      if (currentRow.proposed_stream && currentRow.proposed_single_major && value) {
                                        let selectedMajor = '';
                                        const categoryOptions = CourseCategory[index];
                                        if (categoryOptions && Array.isArray(categoryOptions)) {
                                          const matchedOption = categoryOptions.find(opt =>
                                            String(opt.props?.value) === String(currentRow.proposed_single_major)
                                          );
                                          if (matchedOption) {
                                            selectedMajor = matchedOption.props?.children;
                                          }
                                        }
                                        const selectedBranch = course[index]?.find(c => String(c.course_id) === String(value))?.course_name;
                                        if (!selectedMajor || !selectedBranch) {
                                          return;
                                        }
                                        const existsInExisting = courseData.some(course => {
                                          return course.course_cat_name === selectedMajor &&
                                            course.course_name === selectedBranch;
                                        });
                                        if (existsInExisting) {
                                          Swal.fire({
                                            icon: "warning",
                                            title: "Duplicate Combination",
                                            text: `"${selectedMajor} - ${selectedBranch}" already exists in the existing courses table.`,
                                          });
                                          formik.setFieldValue(`courseConversionDetails[${index}].proposed_change_name`, "");
                                          return;
                                        }

                                        const existsInOtherRows = values.courseConversionDetails.some((row, idx) => {
                                          if (idx === index) return false;
                                          // Get other major from React elements
                                          let otherMajor = '';
                                          const otherCategoryOptions = CourseCategory[idx];
                                          if (otherCategoryOptions && Array.isArray(otherCategoryOptions)) {
                                            const matchedOther = otherCategoryOptions.find(opt =>
                                              String(opt.props?.value) === String(row.proposed_single_major)
                                            );
                                            if (matchedOther) {
                                              otherMajor = matchedOther.props?.children;
                                            }
                                          }
                                          const otherBranch = course[idx]?.find(c => String(c.course_id) === String(row.proposed_change_name))?.course_name;
                                          return otherMajor === selectedMajor && otherBranch === selectedBranch;
                                        });
                                        if (existsInOtherRows) {
                                          Swal.fire({
                                            icon: "warning",
                                            title: "Duplicate Combination",
                                            text: `"${selectedMajor} - ${selectedBranch}" is already selected in another row.`,
                                          });
                                          formik.setFieldValue(`courseConversionDetails[${index}].proposed_change_name`, "");
                                          return;
                                        }
                                        // Check 3: Same as existing course
                                        const existingCourse = courseData.find(c => String(c.course_id) === String(currentRow.existing_course));
                                        if (existingCourse) {
                                          const existingMajor = existingCourse.course_cat_name;
                                          const existingBranch = existingCourse.course_name;
                                          if (existingMajor === selectedMajor && existingBranch === selectedBranch) {
                                            Swal.fire({
                                              icon: "warning",
                                              title: "Same Combination",
                                              text: `"${selectedMajor} - ${selectedBranch}" is the same as the existing course.`,
                                            });
                                            formik.setFieldValue(`courseConversionDetails[${index}].proposed_change_name`, "");
                                            return;
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    <option value="">--Select--</option>
                                    {course[index]?.map((c) => (
                                      <option key={c.course_id} value={c.course_id}>
                                        {c.course_name}
                                      </option>
                                    ))}
                                  </Field>
                                  <ErrorMessage name={`courseConversionDetails[${index}].proposed_change_name`} component="div" className="text-danger small" />
                                </td>
                                <td>
                                  <Field as="select" className="form-control" name={`courseConversionDetails[${index}].mediumCode`} >
                                    <option value="">--Select--</option>

                                    {medium?.map((m, i) => (
                                      <option key={i} value={m.medium_code}>
                                        {m.name}
                                      </option>
                                    ))}
                                  </Field>

                                  <ErrorMessage name={`courseConversionDetails[${index}].mediumCode`} component="div" className="text-danger small" />
                                </td>
                                <td>

                                  {console.log(
                                    "Formik regSelf:",
                                    values.courseConversionDetails[index].regSelf
                                  )}
                                  <Field
                                    name={`courseConversionDetails[${index}].regSelf`}
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={
                                      row.regSelf === "R"
                                        ? "Regular"
                                        : row.regSelf === "S"
                                          ? "Self Finance"
                                          : row.regSelf || ""
                                    } disabled />
                                </td>
                                <td>
                                  <Field
                                    name={`courseConversionDetails[${index}].revised_intake`}
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={row?.existing_intake}
                                    disabled
                                  // onChange={(e) => {
                                  //   const value = e.target.value;
                                  //   formik.setFieldValue(`courseConversionDetails[${index}].revised_intake`, value);
                                  //   formik.validateField(`courseConversionDetails[${index}].revised_intake`);
                                  // }}
                                  />
                                  {/* <ErrorMessage
                                    name={`courseConversionDetails[${index}].revised_intake`}
                                    component="div"
                                    className="text-danger small mt-1"
                                  /> */}
                                </td>
                                {/* <td>{typee === "closure" ? "Closure" : "Conversion of Program"}</td> */}
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => remove(index)}
                                  >
                                    <FaTrash />
                                  </button>
                                </td>

                              </>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </FieldArray>
            </>
          )}
          {formik.values.courseConversionDetails.length > 0 && (
            <jnb.Row className="mt-4">
              <jnb.Col>
                <div className="d-flex justify-content-end mt-4">
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                </div>
              </jnb.Col>
            </jnb.Row>
          )}
        </Form>
      </FormikProvider>
      <style>{`
                .btn-icon { width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; padding: 0; border-radius: 6px; }
                .extra-small { font-size: 0.75rem; }
                .table-dark { --bs-table-bg: #2d3436; }
                .form-control:focus, .form-select:focus { border-color: #74b9ff; box-shadow: 0 0 0 0.2rem rgba(116, 185, 255, 0.25); }
            `}</style>
    </>
  );
};

export default NewConversionProgramForDg;


